/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useLayoutEffect, useRef, useContext } from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from "react-router-dom";
import { createPopper } from '@popperjs/core';
import Icon from '../icon/Icon.js';
import { classNames } from 'primereact/utils';
import { handleLogout } from '../../Services/crypto';

import { getPermisos } from '../../API/IT/Users/UserRequests.js';
import { AuthContext } from '../../Context/AuthContext/AuthContext';
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext.js';
import { getLabel } from '../../Services/Language/LanguageService';
import { baseLang } from '../../Lang/BaseLang';
import { getInformacionEmpresa } from '../../API/Global/InformacionEmpresa/InformacionEmpresaRequest.js';
import { GuardarRegistroMetrica } from '../../API/IT/Metricas/MetricasRequest.js';



const PanelSlider = () => {

    const { userAuth } = useContext(AuthContext);
  const [infEmpresa, setInfEmpresa] = useState([]);
  const { config } = useContext(ConfigContext);

    const ANIMATION_DURATION = 300;
    const btnClose = useRef();

    const [menu, setMenu] = useState();

    const defaultOpenMenus = document.querySelectorAll(".menu-item.sub-menu.open");


    const navigate = useNavigate();
    // const pooper = new Pooper()

    class PopperObject {
        instance = null;
        reference = null;
        popperTarget = null;
        sidebar = null;

        constructor(reference, popperTarget, sidebar) {
            this.init(reference, popperTarget, sidebar);
        }

        init(reference, popperTarget, sidebar) {
            this.sidebar = sidebar;
            this.reference = reference;
            this.popperTarget = popperTarget;
            this.instance = createPopper(this.reference, this.popperTarget, {
                placement: "right",
                strategy: "fixed",
                resize: true,
                modifiers: [
                    {
                        name: "computeStyles",
                        options: {
                            adaptive: false
                        }
                    },
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: ["left", "right"]
                        }
                    }
                ]
            });

            document.addEventListener(
                "click",
                (e) => clicker(e, this.popperTarget, this.reference),
                false
            );

            const clicker = (event, popperTarget, reference) => {
                // console.log(this.sidebar)
                if (
                    this.sidebar.classList.contains("collapsed") &&
                    !popperTarget.contains(event.target) &&
                    !reference.contains(event.target)
                ) {
                    this.hide(popperTarget);
                }
            }

            const ro = new ResizeObserver(() => {
                this.instance.update();
            });

            ro.observe(this.popperTarget);
            ro.observe(this.reference);
        }



        hide(popperTarget) {
            // console.log(popperTarget)
            this.instance.state.elements.popper.style.visibility = "hidden";
        }
    }

    class Poppers {
        subMenuPoppers = [];

        constructor(subMenuELS, sidebar) {
            this.init(subMenuELS, sidebar);
        }

        init(subMenuELS, sidebar) {
            subMenuELS.forEach((element) => {
                this.subMenuPoppers.push(
                    new PopperObject(element, element.lastElementChild, sidebar)
                );
                // console.log(this.subMenuPoppers)
                this.closePoppers();
            });
        }

        togglePopper(target) {
            if (window.getComputedStyle(target).visibility === "hidden")
                target.style.visibility = "visible";
            else target.style.visibility = "hidden";
        }

        updatePoppers() {
            this.subMenuPoppers.forEach((element) => {
                element.instance.state.elements.popper.style.display = "none";
                element.instance.update();
            });
        }

        closePoppers() {
            this.subMenuPoppers.forEach((element) => {
                element.hide();
            });
        }
    }


    const slideUp = (target, duration = ANIMATION_DURATION) => {
        const { parentElement } = target;
        parentElement.classList.remove("open");
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = `${duration}ms`;
        target.style.boxSizing = "border-box";
        target.style.height = `${target.offsetHeight}px`;
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = "none";
            target.style.removeProperty("height");
            target.style.removeProperty("padding-top");
            target.style.removeProperty("padding-bottom");
            target.style.removeProperty("margin-top");
            target.style.removeProperty("margin-bottom");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    };

    const slideDown = (target, duration = ANIMATION_DURATION) => {
        // console.log('SlideDown')
        // console.log(target, duration);
        const { parentElement } = target;
        // console.log(parentElement);
        
        parentElement.classList.add("open");

        // console.log(target.parentElement.classList);

        const t = document.getElementsByClassName('open')
        // console.log({t});


        target.style.removeProperty("display");
        let { display } = window.getComputedStyle(target);
        if (display === "none") display = "block";
        target.style.display = display;
        const height = target.offsetHeight;
        target.style.overflow = "hidden";
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.style.boxSizing = "border-box";
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = `${duration}ms`;
        target.style.height = `${height}px`;
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("box-shadow");

        window.setTimeout(() => {
            target.style.removeProperty("height");
            target.style.removeProperty("overflow");
            target.style.removeProperty("transition-duration");
            target.style.removeProperty("transition-property");
        }, duration);
    };


    const slideToggle = (target, duration = ANIMATION_DURATION) => {
        if (window.getComputedStyle(target).display === "none"){
            // console.log('asfdasd');
            return slideDown(target, duration);
        }
        return slideUp(target, duration);
    };

    defaultOpenMenus.forEach((element) => {
        element.lastElementChild.style.display = "block";
    });





    // Pantalla de Inicio HomeScreen
    const handleHome = () => {
        navigate("/web/Home", { replace: true })
    }

    const setItemsMenu = (contenido, i) => {
        let items = [];
        if (contenido[i].length > 0) {
            contenido[i].forEach((item) => {
                let subNivel = undefined;
                if (contenido[item.IdMenu]?.length > 0) {
                    subNivel = setItemsMenu(contenido, item.IdMenu);
                }
                items.push(
                    {
                        label: config.language === 'es' ? item.Titulo : (item.Title ? item.Title : item.Titulo ),
                        icon: item.Icon,
                        URL: item.URL !== null ? `${process.env.REACT_APP_ENV}/${item.URL}` : undefined,
                        items: subNivel,
                        IdMenu: item.IdMenu,
                    }
                );
            });
        }
        return items;
    }

    const obtenerMenuNew = async () => {
        const inf = await getInformacionEmpresa();
        setInfEmpresa(inf);
        const response = await getPermisos(userAuth?.IdUser);
        let contenido = [];
        const menu = response.menu.filter((item) => item.Menu);
        let panel = [];
        let n = 0
        const t = [...menu].sort((a, b) => a.IdMenu - b.IdMenu); // Ordena el menu por IdMenu en orden ascendente
        n = t[menu.length - 1].IdMenu;
        // menu.forEach((m) => {
        //     n = m.IdMenu
        //   })
        for (let nivel = 0; nivel <= n; nivel++) {
            const tempo = menu.filter((element) => element.IdContainer === nivel);
            contenido[nivel] = tempo;
        }
        panel.push(setItemsMenu(contenido, 0));
        const aux = setItemMenu(panel[0]);
        const nav = (
            <nav className="menu open-current-submenu" >
                {aux}
            </nav >
        )
        setMenu(nav)
    }

    const navegarAMenu = async (item) => {
       navigate(item.URL, { replace: true })
        if(item?.IdMenu && userAuth?.IdRol !==1 && item?.IdMenu !==1){
            const Datos = {
                IdUser: userAuth?.IdUser,
                IdMenu: item?.IdMenu,
                AccesosWeb: userAuth?.AccessWeb || '',
            }
            await GuardarRegistroMetrica(Datos)
        }
    }

    const setItemMenu = (menu) => {
        return <ul id='menu'>
            {/* {console.log(menu)} */}
            {menu.map((item) => {
                return (
                    // TODO TOOLTIP EN EL LI CUANDO ESTE COLAPSADO
                    <li key={item.label} className={classNames('menu-item', { 'sub-menu': item.items !== undefined })} >
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className='navegadorMenu'>
                            <span className='col-11'onClick={(event) => item?.URL ? navegarAMenu(item) : null }>
                                <span className="menu-icon">
                                    <Icon icon={item.icon ?? ''} />
                                </span>
                                <span className="menu-title">{item.label}</span>
                            </span>
                            {item.items === undefined ?
                                <span className={'p-panelmenu-header-link p-panelitem-Redireccion me-2'}
                                    onClick={event => item.URL ? window.open(item.URL) : null}>
                                    {/* // onClick={event => navigate(item.URL, { replace: true })}> */}
                                    <i className="ri-share-circle-line"></i>
                                </span>
                                : ''}
                        </a>
                        {item.items !== undefined ? <div className='sub-menu-list'>{setItemMenu(item.items)}</div> : ''}
                    </li>
                )
            })}
        </ul>
    }



    useLayoutEffect(() => {
        if(userAuth.isLogged){
            obtenerMenuNew();
        }
    }, [userAuth.PermissionMenu, config.language])


    useEffect(() => {
        if (menu) {
            const sidebar = document.getElementById("sidebar");
            const subMenuELS = document.querySelectorAll(
                ".menu > ul > .menu-item.sub-menu"
            );

            const firstSubMenuBTN = document.querySelectorAll(
                ".menu > ul > .menu-item.sub-menu > a"
            );

            const innerSubMenu = document.querySelectorAll(
                ".menu > ul > .menu-item.sub-menu .menu-item.sub-menu > a"
            );


            const poppersInstance = new Poppers(subMenuELS, sidebar);
            /**
             * sidebar collapse handler
             */
            document.getElementById("btn-collapse").addEventListener("click", () => {
                const splitterPanel = document.getElementsByClassName('splitterPanel')
                const [splitterContent] = document.getElementsByClassName('splitterContent')
                splitterPanel[0].style.flexBasis = 'calc(15% - 4px)'
                splitterContent.style.flexBasis = 'calc(85% - 4px)'
                // splitterPanel.current.style.flexBasis = 33;
                btnClose.current.classList.toggle('active')
                sidebar.classList.toggle("collapsed");
                poppersInstance.closePoppers();
                if (sidebar.classList.contains("collapsed"))
                    splitterPanel[0].style.flexBasis = '80px'
                splitterContent.style.flexBasis = 'calc(100% - 84px)'
                firstSubMenuBTN.forEach((element) => {
                    element.parentElement.classList.remove("open");
                });
                updatePoppersTimeout();
            });

            /**
             * sidebar toggle handler (on break point )
             */
            document.getElementById("btn-collapse").addEventListener("click", () => {
                sidebar.classList.toggle("toggled");
                updatePoppersTimeout();
            });

            /**
             * toggle sidebar on overlay click
             */
            document.getElementById("overlay").addEventListener("click", () => {
                sidebar.classList.toggle("toggled");
            });

            /**
     * handle top level submenu click
     */
            firstSubMenuBTN.forEach((element) => {
                element.addEventListener("click", () => {
                    if (sidebar.classList.contains("collapsed"))
                        poppersInstance.togglePopper(element.nextElementSibling);
                    else {
                        const parentMenu = element.closest(".menu.open-current-submenu");
                        if (parentMenu)
                            parentMenu
                                .querySelectorAll(":scope > ul > .menu-item.sub-menu > a")
                                .forEach(
                                    (el) =>
                                        window.getComputedStyle(el.nextElementSibling).display !==
                                        "none" && slideUp(el.nextElementSibling)
                                );
                        slideToggle(element.nextElementSibling);
                    }
                });
            });

            /**
             * handle inner submenu click
             */
            innerSubMenu.forEach((element) => {
                element.addEventListener("click", () => {
                    slideToggle(element.nextElementSibling);
                });
            });

            /**
             * wait for the current animation to finish and update poppers position
             */
            const updatePoppersTimeout = () => {
                setTimeout(() => {
                    poppersInstance.updatePoppers();
                }, ANIMATION_DURATION);
            };
        }
    }, [menu])


    return (
        <div className=''>
            <div className='d-flex justify-content-center'>
                <span id='btn-collapse' aria-describedby="tooltip" style={{ zIndex: 1000 }}>
                    <svg id='svgBtnCollapse' ref={btnClose} className="ham hamRotate ham4 active" viewBox="0 0 100 100" width="50" >
                        <path
                            className="line top"
                            d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
                        <path
                            className="line middle"
                            d="m 70,50 h -40" />
                        <path
                            className="line bottom"
                            d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20" />
                    </svg>
                </span>
            </div>
            <div className="sidebar-header">
                <div className="fila panel_logo_empresa">
                    <div className="columna">
                        <div onClick={handleHome} className="panel_button-home">
                           <img
                                src={
                                    config.theme === "Dark"
                                    ? `data:image/png;base64,${infEmpresa[0]?.LogoPrimarioDarkB64}`
                                    : `data:image/png;base64,${infEmpresa[0]?.LogoPrimarioB64}`
                                }
                                alt="Imagen"
                                className="panel_imagen"
                            />
                            {/* {config.theme === 'Dark' ?  <img src={infEmpresa[0]?.LogoPrimarioDark} alt="Imagen" className="panel_imagen" /> : <img src={infEmpresa[0]?.LogoPrimario}  alt="Imagen" className="panel_imagen" /> } */}
                        </div>
                    </div>
                </div>
            </div>


            <div className="sidebar-content">

                {menu}

            </div>


            <div className="sidebar-footer">
                <Button onClick={e => handleLogout()} icon='pi pi-power-off' label={getLabel(baseLang, 'btnCerrarSecion', config.language)} />
            </div>
        </div>
    )
}

export default PanelSlider